class ct_collection extends HTMLElement {
  constructor() {
    super();
    let autoScrollInterval;
    const precom = this.querySelector("product-recommendations");
    const scrollContainer = precom ? precom.shadowRoot.querySelector(".ct-collection-products") : this.querySelector(".ct-collection-products");
    const btnLeft = this.querySelector(".ct-collection-button-left");
    const btnRight = this.querySelector(".ct-collection-button-right");
    if(btnLeft) {
      btnLeft.addEventListener("click", () => {
        this.scroll("left");
      });
    }
    if(btnRight) {
      btnRight.addEventListener("click", () => {
        this.scroll("right");
      });
    }
    scrollContainer.addEventListener("scroll", () => {
      this.checkScrollPosition();
      if(scrollContainer.hasAttribute("ct-autoscroll")) {
        this.resetAutoScroll();
      }
    });
    if(scrollContainer.hasAttribute("ct-autoscroll")) {
      this.startAutoScroll();
    }
  }
  checkScrollPosition() {
    const precom = this.querySelector("product-recommendations");
    const scrollContainer = precom ? precom.shadowRoot.querySelector(".ct-collection-products") : this.querySelector(".ct-collection-products");
    const btnLeft = this.querySelector(".ct-collection-button-left");
    const btnRight = this.querySelector(".ct-collection-button-right");
    if(scrollContainer.hasAttribute("carousel-pc") || scrollContainer.hasAttribute("carousel-mobile")) {
      if(scrollContainer.scrollLeft == 0) {
        btnLeft.setAttribute("hidden", "");
      } else {
        btnLeft.removeAttribute("hidden");
      }
      const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      if(scrollContainer.scrollLeft >= maxScrollLeft) {
        btnRight.setAttribute("hidden", "");
      } else {
        btnRight.removeAttribute("hidden");
      }
    }
  }
  scroll(direction) {
    const precom = this.querySelector("product-recommendations");
    const scrollContainer = precom ? precom.shadowRoot.querySelector(".ct-collection-products") : this.querySelector(".ct-collection-products");
    let widthToScroll = (scrollContainer.children[0].offsetWidth / 4) * 3;
    if(direction == "left") {
      widthToScroll = -widthToScroll; 
    }
    scrollContainer.scrollBy({ left: widthToScroll, behavior: 'smooth' });
  }
  autoScroll() {
    const precom = this.querySelector("product-recommendations");
    const scrollContainer = precom ? precom.shadowRoot.querySelector(".ct-collection-products") : this.querySelector(".ct-collection-products");
    const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    const widthToScroll = (scrollContainer.children[0].offsetWidth / 4) * 3;

    if (scrollContainer.scrollLeft < maxScrollLeft) {
      scrollContainer.scrollBy({ left: widthToScroll, behavior: 'smooth' });
    } else {
      scrollContainer.scrollTo({ left: 0, behavior: 'smooth' });
    }
  }
  startAutoScroll() {
    const precom = this.querySelector("product-recommendations");
    const scrollContainer = precom ? precom.shadowRoot.querySelector(".ct-collection-products") : this.querySelector(".ct-collection-products");
    const speed = parseInt(scrollContainer.getAttribute("ct-autoscroll"));
    this.autoScrollInterval = setInterval(() => this.autoScroll(), speed);
  }
  resetAutoScroll() {
    clearInterval(this.autoScrollInterval);
    this.startAutoScroll();
  }
}

customElements.define("ct-collection", ct_collection);